import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { lg, md, xl, xl2 } from '../common';

export function initForMen() {
  const parent = document.querySelector('.for-men');
  if (!parent) return;

  const swiper = parent.querySelector('.js-for-men__swiper');
  // const prevEl = parent.querySelector('.swiper-button-prev');
  // const nextEl = parent.querySelector('.swiper-button-next');

  new Swiper(swiper, {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    // loop: true,
    // navigation: {
    //   nextEl,
    //   prevEl,
    // },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      [md]: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        enabled: false,
      },
    },
  });
}
